import styled from "styled-components";

const renderFont = (fontSize: string) => {
  switch (fontSize) {
    case "xxs":
      return `
          font-size: 10px;
          line-height: 16px;
        `;
    case "xs":
      return `
          font-size: 12px;
          line-height: 16px;
        `;
    case "sm":
      return `
          font-size: 14px;
          line-height: 20px;
        `;
    case "md":
      return `
        font-size: 16px;
        line-height: 22px;
      `;
    case "large":
      return `
          font-size: 18px;
          line-height: 24px;
        `;
    case "xlarge":
      return `
        font-size: 22px;
        line-height: 32px;
      `;
    case "xxlarge":
      return `
        font-size: 24px;
        line-height: 32px;
      `;
    case "xxxlarge":
      return `
        font-size: 28px;
        line-height: 32px;
      `;
    default:
      return `
      font-size: 14px;
      line-height: 20px;
    `;
  }
};

const renderFontWeight = (fontWeight: string) => {
  switch (fontWeight) {
    case "regular":
      return `
          font-weight: 400;
        `;
    case "medium":
      return `
        font-weight: 500;
      `;
    case "semiBold":
      return `
        font-weight: 600;
      `;
    case "bold":
      return `
        font-weight: 700;
      `;
    case "extraBold":
      return `
    font-weight: 800;
  `;
    case "black":
      return `
      font-weight: 900;
        `;
    default:
      return `
      font-weight: 400;
    `;
  }
};

export const H1TagStyle: any = styled.h1`
  padding: 0;
  font-size: 56px;
  line-height: 72px;
  font-weight: 500;
  margin: var(--margin, 0);
  font-family: "Raleway";
  color: var(--color, #000);

  span {
    font-size: 56px;
    line-height: 72px;
    font-weight: 500;
    margin: var(--margin, 0);
    font-family: "Raleway";
    color: var(--color, #000);
  }
`;

export const H2TagStyle: any = styled.h2`
  padding: 0;
  font-size: 48px;
  line-height: 64px;
  font-weight: 500;
  margin: var(--margin, 0);
  font-family: "Raleway";
  color: var(--color, #000);
`;

export const H3TagStyle: any = styled.h3`
  padding: 0;
  font-size: 40px;
  line-height: 54px;
  font-weight: 500;
  margin: var(--margin, 0);
  font-family: "Raleway";
  color: var(--color, #000);
  text-align: var(--textAlign, left);
`;

export const H4TagStyle: any = styled.h4`
  padding: 0;
  font-size: 32px;
  line-height: 40px;
  font-weight: 500;
  margin: var(--margin, 0);
  font-family: "Raleway";
  color: var(--color, #000);
`;

export const H5TagStyle: any = styled.h5`
  padding: 0;
  font-size: 24px;
  line-height: 32px;
  margin: var(--margin, 0);
  font-family: "Raleway";
  color: var(--color, #000);
  font-weight: var(--fontWeight, 500);
  span {
    font-size: 24px;
    line-height: 32px;
    font-family: "Raleway";
    font-weight: var(--fontWeight, 500);
  }
`;

export const H6TagStyle: any = styled.h6`
  padding: 0;
  font-size: 16px;
  line-height: 25px;
  font-weight: var(--fontWeight, 500);
  margin: var(--margin, 0);
  font-family: "Raleway";
  color: var(--color, #000);
`;

export const ParaTagStyle: any = styled.p`
  padding: 0;
  font-family: "Open Sans";
  ${(p: any) =>
    p.fontSize
      ? `
    ${renderFont(p.fontSize)}
  `
      : ``}
  ${(p: any) =>
    p.fontWeight &&
    `
    ${renderFontWeight(p.fontWeight)}
  `}
    margin: ${(p: any) => p.margin ?? 0};
  text-align: ${(p: any) => p.textAlign && p.textAlign};
  color: ${(p) => p.color && p.color};
  line-height: ${(p: any) => p.lineHeight && p.lineHeight};
`;

export const SpanTagStyle: any = styled.span<any>`
  font-family: "Open Sans";
  ${(p: any) => (p.fontSize ? `${renderFont(p.fontSize)}` : ``)}
  ${(p: any) => p.fontWeight && `${renderFontWeight(p.fontWeight)}`}
    display: ${(p) => p.display ?? "inline-block"};
  color: ${(p) => p.color && p.color};
  margin: ${(p: any) => p.margin && p.margin};
  text-align: ${(p: any) => p.textAlign && p.textAlign};
  background-color: ${(p: any) => p.bgColor && p.bgColor};
  width: ${(p: any) => p.customWidth && p.customWidth};
`;

export const AnchorTagStyle: any = styled.a`
  color: #008cff;
  text-decoration: none;
  cursor: pointer;
  font-family: "Open Sans";
  ${(p: any) => (p.fontSize ? `${renderFont(p.fontSize)}` : ``)}
  ${(p: any) => p.fontWeight && `${renderFontWeight(p.fontWeight)}`}
    margin: ${(p: any) => p.margin && p.margin};
  display: ${(p: any) => p.display && p.display};
  color: ${(p: any) => p.color && p.color};
  text-align: ${(p: any) => p.textAlign && p.textAlign};
  width: ${(p: any) => p.width && p.width};
  text-transform: ${(p: any) => p.textTransform && p.textTransform};

  &:hover,
  &:focus {
    text-decoration: none;
    outline: none;
  }
`;

export const CliptextStyleComp: any = styled.div`
  background: linear-gradient(
    92.2deg,
    #ffe2e8 0.47%,
    #fffcfc 25.07%,
    #8cc8ea 64.68%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  width: fit-content;
  font-weight: 600;
  margin: ${(props: any) => props.margin && props.margin};
`;
